import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './style.scss';

class DatePickerField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value ? new Date(this.props.value) : null,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({
        value: this.props.value ? new Date(this.props.value) : null,
      });
    }
  }

  onChange = (selectedDate) => {
    const { onChange } = this.props;
    this.setState({
      value: selectedDate,
    });
    onChange(selectedDate);
  };

  render() {
    const { minimumDate, maximumDate, disabled, placeholder, hasError, placement, showMonthYearDropdown } = this.props;
    const { value } = this.state;

    return (
      <div className="date-picker-field">
        <div className={`date-picker-field-wrapper ${value ? 'has-value' : ''} ${hasError ? 'has-error' : ''}`}>
          <div className="date-picker-field-content">
            <DatePicker
              disabled={disabled}
              selected={value}
              onChange={this.onChange}
              minDate={minimumDate}
              maxDate={maximumDate}
              placeholderText={placeholder || 'Select date...'}
              customInput={<CustomInput placeholder={placeholder} isSelected={!!value} hasError={hasError} />}
              shouldCloseOnSelect={true}
              popperPlacement={placement}
              {...(showMonthYearDropdown
                ? {
                    showMonthDropdown: true,
                    showYearDropdown: true,
                    dropdownMode: 'scroll',
                    scrollableYearDropdown: true,
                    yearDropdownItemNumber: 25,
                  }
                : {})}
            />
          </div>
        </div>
      </div>
    );
  }
}

const CustomInput = ({ value, onClick, placeholder, isSelected, hasError }) => {
  const formatDisplayValue = (val) => {
    if (!val) return placeholder || 'Select date...';

    if (typeof val === 'string') return val;

    if (val instanceof Date && !isNaN(val.getTime())) {
      return val.toLocaleDateString();
    }

    try {
      const date = new Date(val);
      if (!isNaN(date.getTime())) {
        return date.toLocaleDateString();
      }
    } catch (e) {
      console.warn('Invalid date value:', val);
    }

    return placeholder || 'Select date...';
  };

  return (
    <div
      onClick={onClick}
      className={`date-picker-custom-input ${hasError ? 'has-error' : ''}`}
    >
      <span>{formatDisplayValue(value)}</span>
      <i 
        className={`fa fa-calendar ${isSelected ? 'has-value' : ''}`}
      ></i>
    </div>
  );
};

DatePickerField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  minimumDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  maximumDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  hasError: PropTypes.bool,
  popperPlacement: PropTypes.string,
  showMonthYearDropdown: PropTypes.bool,
};

DatePickerField.defaultProps = {
  label: '',
  value: null,
  minimumDate: null,
  maximumDate: null,
  disabled: false,
  placeholder: 'Select date...',
  hasError: false,
  popperPlacement: '',
  showMonthYearDropdown: false,
};

export default DatePickerField;
